module.exports = __webpack_public_path__ + "img/banner-3.19c7ee1f.jpg";